var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 58,
    viewBox: "0 0 42 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.264 39.3521C25.264 45.0867 25.2679 50.4008 25.2602 55.7111C25.2563 58.2689 24.8146 58.5219 22.5831 57.2294C15.5979 53.1805 8.63217 49.1083 1.62378 45.1023C0.484768 44.4521 -0.0150032 43.7319 0.00436783 42.3615C0.0857277 36.9812 0.0702286 31.597 0.0159912 26.2166C0.00436783 25.0253 0.39566 24.3324 1.43007 23.7484C5.81564 21.2685 10.147 18.699 14.5132 16.1879C16.2798 15.1718 16.8183 15.4755 16.8222 17.5038C16.8416 22.561 16.8609 27.6221 16.8067 32.6793C16.7951 33.8667 17.167 34.583 18.2208 35.1514C20.4368 36.3388 22.5831 37.6508 25.0703 39.0913C25.1129 38.1725 25.1749 37.5067 25.1749 36.8371C25.1827 25.3601 25.1788 13.8793 25.1827 2.40231C25.1827 -0.330677 25.5507 -0.548698 27.8791 0.833366C32.0981 3.34055 36.2861 5.90223 40.5322 8.3627C41.6324 8.99728 42.0082 9.74477 42.0044 11.0023C41.9617 22.7401 41.9811 34.4779 41.9734 46.2157C41.9734 48.5204 41.5278 48.7657 39.4978 47.5978C34.872 44.9232 30.2501 42.2369 25.264 39.3521Z",
    fill: "url(#paint0_linear_1_248)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_248",
    x1: 12.8415,
    y1: 51.7222,
    x2: 40.7358,
    y2: 12.7356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0E75"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.2cb5ca2e391f5cc45954eab4b4ec7105.svg";
export { ForwardRef as ReactComponent };